import { ApiError } from "api/httpClients/clients/http.client";

/**
 * Returns a user-friendly error message based on the provided error object.
 *
 * @param error - The error object to extract the message from.
 * @returns A string containing the error message.
 */
export function getQueryErrorMessage(error: unknown): string {
  if (error instanceof ApiError) {
    const body = error.body as { message?: string } | null;
    if (typeof body?.message === "string" && body.message.trim()) {
      return body.message;
    }
    if (error.status >= 500) {
      return "A server error occurred. Please try again later.";
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return "Unable to load data. Please try again.";
}
